import { AppSpan, AppText, Button, CustomContainer, FlexRow, GridContainer, ScreenTitle } from "src/style"
import { SidePopupLayout } from "src/component"
import { moneyFormat } from "src/utils/utility"
import helpers from "src/utils/helpers"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"
import { useContext } from "react"

export const InvestmentConfirmation: React.FC<any> = ({data, type, next, back, close}) => {
    const {info: {institutionData}} = useContext(AppInfoContext)


    return (
        <SidePopupLayout close={close}>
            <ScreenTitle textSize="2.2" fontWeight="700">Confirm Payment</ScreenTitle>
            <CustomContainer topMargin="2.5">
                <AppSpan>See below {type === 'savings' ? 'savings' : 'investment'} confirmation</AppSpan>
                <CustomContainer
                    minHeight="19.6" borderColor="#EAECF0" padding="2" radius="0.8" topMargin="2"
                >
                    <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap">
                        <GridContainer width="auto" sizeUnit="" alignItems="start">
                            <AppSpan>Amount</AppSpan>
                            <AppText fontWeight="700" color="#0D968F" fontFamily="Gilmer-Bold">
                                {moneyFormat(data?.amount,institutionData?.defaultCurrency)}
                            </AppText>
                        </GridContainer>
                        <GridContainer width="auto" sizeUnit="" alignItems="end">
                            <AppSpan>Tenure</AppSpan>
                            <AppText fontWeight="700" color="#0D968F" fontFamily="Gilmer-Bold">{data?.tenure} Days</AppText>
                        </GridContainer>
                    </FlexRow>
                    <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap">
                        <GridContainer width="auto" sizeUnit="" alignItems="start">
                            <AppSpan>Start Date</AppSpan>
                            <AppText fontWeight="700" color="#0D968F" fontFamily="Gilmer-Bold">{data?.startDate}</AppText>
                        </GridContainer>
                        <GridContainer width="auto" sizeUnit="" alignItems="end">
                            <AppSpan>Maturity Date</AppSpan>
                            <AppText fontWeight="700" color="#0D968F" fontFamily="Gilmer-Bold">
                                {helpers.splitDateTime(data?.maturationDate || '0000-01-01T00:00:00').slashedDate}
                            </AppText>
                        </GridContainer>
                    </FlexRow>
                    <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap">
                        <GridContainer width="auto" sizeUnit="" alignItems="start">
                            <AppSpan>Expected Return</AppSpan>
                            <AppText fontWeight="700" color="#0D968F" fontFamily="Gilmer-Bold">
                                {moneyFormat(data?.expectedReturn || 0, true,institutionData?.defaultCurrency)}
                            </AppText>
                        </GridContainer>
                        { type === 'savings' &&
                            <GridContainer width="auto" sizeUnit="" alignItems="end">
                                <AppSpan>Goal</AppSpan>
                                <AppText fontWeight="700" color="#0D968F" fontFamily="Gilmer-Bold">Car Savings</AppText>
                            </GridContainer>
                        }
                    </FlexRow>
                </CustomContainer>
                <FlexRow justifyContent='flex-end' gap="1.5" topMargin="2.5">
                    <Button 
                        width='6.7' height='4' bgColor="#ffffff"
                        borderColor='#D0D5DD' hoverBgColor='#ffffff' 
                        hoverColor='#0D968F' titleSize='1.4' color="#344054"
                        onClick={back}
                    >
                        Back
                    </Button>
                    <Button 
                        width='8.7' height='4' 
                        borderColor='#0D968F' hoverBgColor='#ffffff' 
                        hoverColor='#0D968F' titleSize='1.4'
                        onClick={next}
                    >
                        Confirm
                    </Button>
                </FlexRow>
            </CustomContainer>
        </SidePopupLayout>
    )
}